import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { applyRuntimeProfile } from './utils/platform.js'
import { registerServiceWorker } from './registerServiceWorker.js'
import { installTvNavigation } from './utils/tvNavigation.js'
import { initializeAppearance } from './services/appearance.js'

initializeAppearance()
const runtimeProfile = applyRuntimeProfile()
createApp(App).use(store).use(router).mount('#app')
if (runtimeProfile.isWebOs) installTvNavigation()
registerServiceWorker()
